export default [{
  path: '/wechat/:site/',
  name: 'wechat.home',
  component: () => import('@/views/admin/Index.vue'),
  children: [{
      path: 'service',
      name: 'wechat.service',
      component: () => import('@/views/wechat/service/Index.vue')
    },
    {
      path: 'fans',
      name: 'wechat.fans',
      component: () => import('@/views/wechat/fans/Index.vue')
    },
    {
      path: 'templet',
      name: 'wechat.templet',
      component: () => import('@/views/wechat/templet/Index.vue')
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/modules/wechat.js